import {ComponentDefinition} from '@contentful/experiences-sdk-react';

export const AFEEligibilityContentfulComponentDefinition: ComponentDefinition =
  {
    id: 'afeEligibility',
    name: 'AFE Eligibility',
    category: '08: Advanced',
    thumbnailUrl:
      'https://contentful-images.code.org/90t6bu6vlf76/1KBqVuN3E8F9xCfpqm9mDh/1a0aaa4e1580355e7b696b0512303155/component_afe_icon.png',
    tooltip: {
      description:
        'Embeds the Amazon Future Engineer eligibility form. This component is case-specific and intended for use on a specific page only.',
      imageUrl:
        'https://contentful-images.code.org/90t6bu6vlf76/45xOdiOzDWKEs3AZDL8fSe/c79d09ed7bd7a82488fb7e75e83db715/component_afe_tooltip.png',
    },
    variables: {},
  };
